import { formatDate } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const FALLBACK_LANG = 'en';

// Apps register the locale data of every language listed here (registerLocaleData)
const LOCALE_FORMATS: Readonly<Record<string, string>> = {
  en: 'MMM dd, yyyy, HH:mm:ss',
  it: 'dd MMM yyyy, HH:mm:ss',
};

/**
 * Angular date formatting in the current translation language, so dates follow a language switch.
 * Without a format it uses the language's date-time pattern.
 */
@Pipe({
  name: 'dateFormat',
  pure: false,
})
export class DateFormatPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  public transform(
    value: string | number | Date | null | undefined,
    format?: string | null,
    timezone?: string
  ): string | null {
    if (!value) {
      return null;
    }

    const lang = this.translate.currentLang in LOCALE_FORMATS ? this.translate.currentLang : FALLBACK_LANG;

    return formatDate(value, format || LOCALE_FORMATS[lang], lang, timezone);
  }
}
